import { render, staticRenderFns } from "./CreateNewVenue.vue?vue&type=template&id=4a5536f8&scoped=true&"
import script from "./CreateNewVenue.vue?vue&type=script&lang=js&"
export * from "./CreateNewVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5536f8",
  null
  
)

export default component.exports